import styled from 'styled-components';
import { CloseCircleFilled } from '@ant-design/icons';

export default styled(CloseCircleFilled)`
    font-size: 20px;
    color: ${({ theme }) => theme.text};
    cursor: pointer;
`;
